module.exports = __webpack_public_path__ + "img/main_ylw.0af79862.jpg";